export enum InitialAuthErrorCode {
    NoInternet = 'no_internet',
    Unknown = 'unknown',
}
